import type { VoidFunctionComponent } from 'react';
import Icon, { icons } from '../../../generic/Icon';
import Link from '../../../generic/Link';
import ListRowDetailsSeparator from '../../../generic/List/ListRowDetailsSeparator';
import sharedStyles from '../IssueDetails.module.less';
import styles from './IssueDetailsProjectsTable.module.less';

type Props = {
  jiraTicketId: string;
  jiraTicketURL: string;
};

/**
 * IssueDetailsProjectTableJiraTicketLink displays a link to
 * the Jira ticket associated with a given project issue.
 */
const IssueDetailsProjectTableJiraTicketLink: VoidFunctionComponent<Props> = ({ jiraTicketId, jiraTicketURL }) => (
  <>
    <ListRowDetailsSeparator />
    <Link
      to={jiraTicketURL}
      className={`${sharedStyles.projectStatus} ${styles.ticketLink}`}
      openInNewTab
    >
      <span className={`${sharedStyles.icon} ${sharedStyles.ticketedIcon}`}>
        <Icon icon={icons.ticket} />
      </span>
      {jiraTicketId}
      <span className={`${sharedStyles.icon} ${styles.ticketLinkIcon}`}>
        <Icon icon={icons.externalLink} />
      </span>
    </Link>
  </>
);

export default IssueDetailsProjectTableJiraTicketLink;
